import { Button } from 'antd'
import { useEffect, useState } from 'react'
import styled from 'styled-components'
import { useHistory, useLocation } from 'react-router-dom'
import { orderService } from 'services'
import { createGlobalStyle } from 'styled-components'
import { API_BASE_URL } from 'constants/index';
import * as qs from 'query-string'
import { getAuthToken } from 'helpers/FetchHelper'
import InDon from 'components/Printer/Indon'

const GlobalStyle = createGlobalStyle<{ numPages: number }>`
  @media print {
    html, body {
      height: ${(props) => props.numPages * 209}mm;
      margin: 0 !important; 
      padding: 0 !important;
      overflow: hidden;
    }
  }
`

const Wrapper = styled.div<{ scale: number }>`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 14px;
  line-height: 1.42857143;
  transform: scale(${(props) => props.scale});
  transform-origin: top center;
  width: 100%;
  p {
  margin: 0 0 4px;
  }
  @media print {
    transform: none !important;
    width: 100% !important;
  }

  @page {
    size: A5;
  }

  .sheet {
    margin-left: auto;
    margin-right: auto;
    padding: 10mm 6mm;
    width: 148mm;
    height: 209mm;
    margin-bottom: 0;
  }

  .border-top {
    border-top: 1px dotted black;
    max-width: 100% !important;
  }

  .main-content {
    p {
      margin-top: 4px;
      margin-bottom: 0px;
    }
  }

  b {
    display: contents;
  }

  .box-qr {
    width: 50%;

    svg {
      width: 150px;
      height: 150px;
    }
  }

  .box-barcode {
    text-align: center;
  }
    .box-barcode svg{
        width: 385px;
        height: 130px;
    }
`

const Page = () => {
  const location = useLocation()

  const { id, list_id } = qs.parse(location.search)
  const history = useHistory()
  const auth = getAuthToken();

  const [loadingDownload, setLoadingDownload] = useState<boolean>(false)
  const [dataDetail, setDataDetail] = useState<any[]>()
  const [security, setSecurity] = useState<boolean>()
  const [scale, setScale] = useState(1)

  useEffect(() => {
    const updateScale = () => {
      const scaleValue = Math.min(window.innerWidth / 800, 1)
      setScale(scaleValue)
    }

    updateScale()
    window.addEventListener('resize', updateScale)

    return () => window.removeEventListener('resize', updateScale)
  }, [])

  useEffect(() => {
    orderService.getListDetail(
      +(list_id || 0),
      +(id || 0),
      (data) => {
        if (data?.data) {
          setDataDetail(data?.data?.orders)
        } else {
          history.goBack()
        }
      },
      () => {
        history.goBack()
      }
    )
  }, [history, id])

  const openPrint = () => {
    const printButton: any = document.getElementById('printButton')
    printButton.style.display = 'none'
    const btnSecurity: any = document.getElementById('btnSecurity')
    btnSecurity.style.display = 'none'
    const downloadPdfButton: any = document.getElementById('downloadPdfButton')
    downloadPdfButton.style.display = 'none'
    window.print()
  }
  const onSecurity = () => {
    setSecurity(!security);
  }
  const downloadPdf = async () => {
    setLoadingDownload(true)
    const response = await fetch(
      `${API_BASE_URL}/orders/get-pdf-order?list_id=${+(list_id || 0)}&id=${+(id || 0)}`,
      {
        method: 'GET',
        headers: {
          Accept: 'application/pdf',
          Authorization: `Bearer ${auth}`,
        },
      }
    );

    if (response.status === 200) {
      setLoadingDownload(false)
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob)
      window.location.href = objectUrl
    } else {
      history.push('/');
    }
  }

  window.onafterprint = function () {
    const printButton: any = document.getElementById('printButton')
    printButton.style.display = 'block'
    const btnSecurity: any = document.getElementById('btnSecurity')
    btnSecurity.style.display = 'block'
    const downloadPdfButton: any = document.getElementById('downloadPdfButton')
    downloadPdfButton.style.display = 'block'
  }

  useEffect(() => {
    // Tạo thẻ link cho CSS
    const paperCss = document.createElement('link')
    paperCss.rel = 'stylesheet'
    paperCss.href = 'https://cdnjs.cloudflare.com/ajax/libs/paper-css/0.3.0/paper.css'

    const bootstrapCss = document.createElement('link')
    bootstrapCss.rel = 'stylesheet'
    bootstrapCss.href = 'https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css'

    // Thêm các thẻ link vào head
    document.head.appendChild(paperCss)
    document.head.appendChild(bootstrapCss)

    // Xóa các thẻ link khi component unmount
    return () => {
      document.head.removeChild(paperCss)
      document.head.removeChild(bootstrapCss)
    }
  }, [])

  return (
    <>
      <GlobalStyle numPages={dataDetail?.length as number} />
      <Button

        id='printButton'
        type='primary'
        icon={<span className='glyphicon glyphicon-print' style={{ marginRight: 6 }} />}
        onClick={openPrint}
        style={{ position: 'fixed', top: 10, right: 10, zIndex: 10, transform: `scale(${scale})` }}
      >
        In File khổ giấy A5
      </Button>
      <Button
        id='btnSecurity'
        icon={<span className='glyphicon glyphicon-eye-close' style={{ marginRight: 6 }} />}
        onClick={onSecurity}
        style={{ position: 'fixed', top: 55 * scale, right: 10, zIndex: 10, transform: `scale(${scale})` }}
      >
        Bảo mật thông tin
      </Button>
      <Button
        loading={loadingDownload}
        id='downloadPdfButton'
        icon={<span className='glyphicon glyphicon-file' style={{ marginRight: 6 }} />}
        onClick={downloadPdf}
        style={{ position: 'fixed', top: 98 * scale, right: 10, zIndex: 10, transform: `scale(${scale})` }}
      >
        Lưu thành file pdf
      </Button>

      <Wrapper scale={scale}>
        <InDon security={security} dataDetail={dataDetail} />
      </Wrapper>
    </>
  )
}

export default Page
